import { render, staticRenderFns } from "./DetalleGastosViaje.vue?vue&type=template&id=52e0f258&"
import script from "./DetalleGastosViaje.vue?vue&type=script&lang=js&"
export * from "./DetalleGastosViaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleGastosViaje.vue"
export default component.exports